module.exports = __webpack_public_path__ + "img/50d.5560e3a6.png";